<ng-container [formGroup]="form">
    <ng-container [formGroup]="form">
        <mat-form-field apperance="fill" [ngClass]="class" class="w-full">
            <mat-label> {{label | transloco}}</mat-label>
            <mat-select [formControlName]="controlName" placeholder="{{label |transloco}}" [multiple]="multiple" [disabled]="disabled">
               
                <mat-option *ngFor="let option of options" [value]="option">
                    {{option }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get(controlName)?.hasError('required')"> {{label|transloco}} {{'Is Required' |transloco}}</mat-error>
        </mat-form-field>
    </ng-container>